import React, { useEffect, useMemo, useState } from 'react';
import {
  CDropdown,
  CDropdownDivider,
  CDropdownMenu,
  CDropdownToggle,
} from '@coreui/react';
import usePortal from 'react-useportal/dist/usePortal';
import CIcon from '@coreui/icons-react';
import { useSelector } from 'react-redux';
import Filter from './Filter';
import { selectTechnicians } from '../../../store/selectors/user.selectors';
import { selectOrgDescendants } from '../../../store/selectors/store.selectors';

const UNASSIGNED = {
  displayName: 'Unassigned',
  id: -1
};

interface FiltersProps {
  onFilterChange: (args) => void;
}

const Filters = (props: FiltersProps) => {
  const {
    onFilterChange
  } = props;

  const { Portal } = usePortal({
    bindTo: document && document.querySelector('body')
  });

  const agents = useSelector(selectTechnicians) || [];
  const orgs = useSelector(selectOrgDescendants) || [];
  const allAgents = useMemo(() => [
    ...agents,
    UNASSIGNED
  ], [agents]);
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [selectedOrgs, setSelectedOrgs] = useState([]);

  useEffect(() => {
    onFilterChange({
      agents: selectedAgents.map(item => item.value),
      orgs: selectedOrgs.map(item => item.value)
    })
  }, [selectedAgents, selectedOrgs]);

  const orgOptions = useMemo(() => {
    return orgs?.map(agent => ({
      label: agent.name,
      value: agent._id,
    }));
  }, [orgs]);

  const agentOptions = useMemo(() => {
    return allAgents?.map(agent => ({
      label: agent.displayName,
      value: agent.id,
    }))
  }, [allAgents]);

  return (
    <CDropdown>
      <CDropdownToggle
        caret
        size='xs'
        color='primary'
        className='bg-color-orange border-0'
      >
        <CIcon name="cil-filter" />
      </CDropdownToggle>
      <Portal>
        <CDropdownMenu>
          <Filter options={agentOptions} handleChange={setSelectedAgents} selectedItems={selectedAgents} label="Agents:" />
          <CDropdownDivider/>
          <Filter options={orgOptions} handleChange={setSelectedOrgs} selectedItems={selectedOrgs} label="Organizations:"/>
        </CDropdownMenu>
      </Portal>
    </CDropdown>
  );
};

export default Filters;
